"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorImage = void 0;
class SensorImage {
    width;
    height;
    stats;
    constructor(width, height, stats) {
        this.width = width;
        this.height = height;
        this.stats = stats;
    }
    toCameraCoordinates(pixelX, pixelY, depthOverride) {
        const depth = typeof depthOverride === 'number' ? depthOverride : this.getRaw(pixelX, pixelY).depth;
        return this.pixelDepthToCameraCoordinates(pixelX, pixelY, depth);
    }
    toCameraCoordinatesWithLensTable({ depth, x, y, lensTable }) {
        const column = x - (this.width / 2) + 1;
        const row = y - (this.height / 2) + 1;
        const pixelSize = this.pixelWidthOnSensorInMm();
        const pixelRadius = pixelSize * Math.sqrt(((column - 0.5) ** 2) + ((row - 0.5) ** 2));
        const phiInGradians = lensTable.phi(pixelRadius);
        const polarCoords = {
            phi: phiInGradians * 0.015708,
            theta: Math.atan2(row - 0.5, column - 0.5),
            r: depth,
        };
        return {
            x: polarCoords.r * Math.sin(polarCoords.phi) * Math.cos(polarCoords.theta),
            y: polarCoords.r * Math.sin(polarCoords.phi) * Math.sin(polarCoords.theta),
            z: polarCoords.r * Math.cos(polarCoords.phi),
        };
    }
    toCameraCoordinatesWithNaiveLens({ depth, x, y }) {
        const fov = this.fieldOfView();
        const theta = (y - (this.height / 2)) * ((fov.yDegrees * Math.PI / 180) / (this.height - 1));
        const beta = (x - (this.width / 2)) * ((fov.xDegrees * Math.PI / 180) / (this.width - 1));
        const x2 = depth * Math.sin(beta) * Math.cos(theta);
        const y2 = depth * Math.sin(theta);
        const z2 = depth * Math.cos(beta) * Math.cos(theta);
        return { x: x2, y: y2, z: z2 };
    }
}
exports.SensorImage = SensorImage;
